export default __webpack_public_path__ + "static/media/image28.dde55602.png";